// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
	production: false,
	USER_POOL_ID: "us-east-2_kqELi90BJ",
	CLIENT_ID: "7f3k96mtm2u7mret4paqd6iijb",
	IDENTITY_POOL_ID: "us-east-2:6cbc2e72-fb44-4e78-b9b7-bea6d4ef4fe2",
	API_HOST: "https://api-dev.cloud.impulse.com",
	RECAPTCHA_SITE_KEY: "6LdfqDEUAAAAADHWdfCGIQU7RaKSyBRvBo-QdaUT",
	DOWNLOAD_SITE: "https://download-dev.cloud.impulse.com",
	DEMO_SITE: "http://demo.cloud.impulse.com",
	REGISTRATION_SITE: "https://sdp-dev.cloud.impulse.com",
	GATEWAY_MANIFEST_URL: "https://d-dev.cloud.impulse.com/gateway/manifest.json"
};
